import React from "react";
import { useTranslation } from "react-i18next";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";

const LeftSection = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center lg:items-start gap-4">
      <h1 className="text-4xl md:text-5xl font-bold">{t("contact.main.title")}</h1>
      <p className="text-black text-opacity-80 w-full max-w-[500px] md:text-lg text-center lg:text-left sm:pb-2 lg:py-6">
        {t("contact.main.desc")}
      </p>

      <div className="flex flex-col md:flex-row lg:flex-col gap-4 w-full">
        <div className="flex flex-row items-center gap-4 p-4 rounded-lg border bg-white w-full flex-1 lg:max-w-[385px]">
          <img
            src="/assets/contact/email.svg"
            alt="email"
            className="h-10 w-10"
          />
          <div className="flex flex-col gap-1">
            <p className="text-xl font-semibold">
              {t("contact.main.email_title")}
            </p>
            <a
              className="text-pr hover:text-sr transition-all duration-300"
              href={`mailto:${t("contact.main.email_link")}`}
            >
              {t("contact.main.email_link")}
            </a>
          </div>
        </div>
        <div className="flex flex-row items-center gap-4 p-4 rounded-lg border bg-white w-full flex-1 lg:max-w-[385px]">
          <img
            src="/assets/contact/support.svg"
            alt="support"
            className="h-10 w-10"
          />
          <div className="flex flex-col gap-1">
            <p className="text-xl font-semibold">
              {t("contact.main.support_title")}
            </p>
            <Link
              className="group text-pr hover:text-sr transition-all duration-300 flex flex-row gap-3 items-center"
              to="/support"
            >
              <p>{t("contact.main.support_link")}</p>
              <BsArrowRight className="text-lg group-hover:translate-x-2 transition-all" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSection;
